import { GatewayStatus } from 'constants/gatewayStatuses';

import {
  ActiveIconStyled,
  DisabledIconStyled,
  TestIconStyled,
  PilotIconStyled,
} from './GatewayStatusIcon.styled';

type Props = {
  status: GatewayStatus;
};

export const GatewayStatusIcon: React.FC<Props> = ({ status }) => {
  switch (status) {
    case GatewayStatus.Active:
      return <ActiveIconStyled />;
    case GatewayStatus.Disabled:
      return <DisabledIconStyled />;
    case GatewayStatus.Test:
      return <TestIconStyled />;
    case GatewayStatus.Pilot:
      return <PilotIconStyled />;
    default:
      return null;
  }
};
